import React from 'react';
import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useCompetitions } from './CompetitionContext';
import RequireVip from './RequireVip';
import { getCompetitionToolRequirement } from '../utils/accessControl';

export default function CompetitionAccessGate({ children, requirementField = 'stats_requirement', competitionIdOverride }) {
  const params = useParams();
  const competitionId = Number(competitionIdOverride || params.competitionId || params.id);
  const { competitions, loading } = useCompetitions();

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography>Ładowanie...</Typography>
      </Box>
    );
  }

  const competition = Object.values(competitions || {})
    .flat()
    .find((comp) => Number(comp.competition_id) === competitionId);

  const requirement = getCompetitionToolRequirement(competition, requirementField);

  return (
    <RequireVip variant="vip-teaser" requirement={requirement}>
      {children}
    </RequireVip>
  );
}
